'use strict';

var normalize = require('mdurl/encode');
var all = require('../all');
module.exports = link;
function link(h, node) {
  var props = {
    href: normalize(node.url)
  };
  if (node.title !== null && node.title !== undefined) {
    props.title = node.title;
  }
  return h(node, 'a', props, all(h, node));
}